var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popover',{attrs:{"id":_vm.id,"position":_vm.position}},[_c('img',{staticClass:"ico-option",attrs:{"src":require("@img/icons/icon-options.svg?inline"),"alt":"Opções"}}),_c('template',{slot:"popover"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }